/** Header keys used across the API client. */
export const HTTP_HEADERS = {
  authorization: 'Authorization',
  tenantSlug: 'x-tenant-slug',
  requestId: 'x-request-id',
  idempotencyKey: 'x-idempotency-key',
  testOtpSecret: 'x-test-otp-secret',
} as const;

/** localStorage keys — namespaced under cc-admin to avoid collisions. */
export const STORAGE_KEYS = {
  authToken: 'cc-admin:auth:token',
  refreshToken: 'cc-admin:auth:refresh-token',
  user: 'cc-admin:auth:user',
  membership: 'cc-admin:auth:membership',
  pendingPhone: 'cc-admin:auth:pending-phone',
  sidebarCollapsed: 'cc-admin:layout:sidebar-collapsed',
} as const;

export const APP_PLATFORM = 'WEB' as const;
